import React from 'react';
import './MainContent.css';

const MainContent = ({ 
  isPinned,
  selectedView,
  activeTab,
  isMobile,
  analysisHeader,
  dataView,
  mapView,
  captureRef,
  printFooterUrl = '',
  printDataSourceLabel = '',
}) => {
  return (
    <main className="main-content" data-pinned={isPinned}>
      {isMobile && (
        <div className="mobile-analysis-header">
          {analysisHeader}
        </div>
      )}

      <div className="split-view">
        <div 
          ref={captureRef}
          className="split-view-content" 
          data-active={selectedView === 'chart' || selectedView === 'table'}
          data-reports={activeTab === 'reports'}
          data-print-url={printFooterUrl}
          data-print-data-source={printDataSourceLabel}
        >
          {!isMobile && analysisHeader}
          {dataView}
        </div>
        <div className="split-view-map" data-active={selectedView === 'map'}>
          <div className="map-container">
            {mapView}
          </div>
        </div>
      </div>
    </main>
  );
};

export default MainContent;